// extracted by mini-css-extract-plugin
export default {"container":"MerchCancel_container__2Mfrj","h1":"MerchCancel_h1__s+ZqY","imageBox":"MerchCancel_imageBox__a5820","thankYouNote":"MerchCancel_thankYouNote__1koUz"};